/* LMRBState.js */

"use strict";
const QUADRANTS = ["left", "middle", "right", "bottom"];
const _ = require("lodash");
const EventEmitter = require("events");
const QuadrantState = require("./QuadrantState");

class LMRBState extends EventEmitter {
    constructor(di) {
        super();
        this._di = di;
        QUADRANTS.forEach((quadName) => {
            this[quadName] = new QuadrantState(quadName, this._di);
            this[quadName].on("stateChanged", () => {
                this.emit("stateChanged", this, quadName);
            });
        });
        this.bottom.on("quadrantSizeChanged", () => {
            this.left.notifyPartSizeChanged();
            this.middle.notifyPartSizeChanged();
            this.right.notifyPartSizeChanged();
        });
        this.left.on("quadrantSizeChanged", () => {
            this.left.notifyPartSizeChanged();
            this.middle.notifyPartSizeChanged();
        });
        this.right.on("quadrantSizeChanged", () => {
            this.right.notifyPartSizeChanged();
            this.middle.notifyPartSizeChanged();
        });
    }

    getDI() {
        return this._di;
    }

    get DI() {
        return this.getDI();
    }

    addPart(quadrant, partName, partId, options, silent) {
        this[quadrant].addPart(partName, partId, options, silent);
    }

    notifyWindowSizeChanged() {
        this.forEachQuadrantState((quadrant) => {
            quadrant.notifyPartSizeChanged();
        });
    }

    forEachQuadrantState(callback) {
        QUADRANTS.forEach((name) => {
            callback(this[name]);
        });
    }

    findQuadrantForPartId(id) {
        return _.find(QUADRANTS, (name) => {
            return this[name].getActivePart(id);
        });
    }

    findQuadrantForAvailablePart(partName) {
        return _.find(QUADRANTS, (name) => {
            return this[name].getAvailablePart(partName);
        });
    }

    updateState(stateObj) {
        QUADRANTS.forEach((quadName) => {
            if (_.hasIn(stateObj, quadName)) {
                this[quadName].updateState(stateObj[quadName]);
            }
        });
    }

    toJSON() {
        let that = this;
        let obj = {};

        QUADRANTS.forEach((name) => {
            obj[name] = that[name].toJSON();
        });
        return obj;
    }

    shutdown() {
        this.removeAllListeners();
        QUADRANTS.forEach((quadName) => {
            this[quadName] = null;
        });
    }
}

module.exports = LMRBState;
